import { createContext } from "react";

import type { QueryStringStateManager } from "./query-string-state-manager";

export const QueryStringStateManagerContext = createContext<
  QueryStringStateManager | undefined
>(undefined);
